const GUEST_WISHLIST_STORAGE_KEY = 'sree-silks.web.guest-wishlist';

export type GuestWishlistItem = {
  productId: string;
  variantId?: string | null;
};

function isBrowser() {
  return typeof window !== 'undefined';
}

export function getGuestWishlist(): GuestWishlistItem[] {
  if (!isBrowser()) {
    return [];
  }

  try {
    const raw = window.localStorage.getItem(GUEST_WISHLIST_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function saveGuestWishlist(items: GuestWishlistItem[]) {
  if (!isBrowser()) {
    return;
  }

  window.localStorage.setItem(GUEST_WISHLIST_STORAGE_KEY, JSON.stringify(items));
}

export function addGuestWishlistItem(item: GuestWishlistItem) {
  const existing = getGuestWishlist();
  const next = existing.some(
    (entry) => entry.productId === item.productId && (entry.variantId ?? null) === (item.variantId ?? null)
  )
    ? existing
    : [...existing, item];
  saveGuestWishlist(next);
  return next;
}

export function removeGuestWishlistItem(item: GuestWishlistItem) {
  const next = getGuestWishlist().filter(
    (entry) => !(entry.productId === item.productId && (entry.variantId ?? null) === (item.variantId ?? null))
  );
  saveGuestWishlist(next);
  return next;
}

export function clearGuestWishlist() {
  if (!isBrowser()) {
    return;
  }

  window.localStorage.removeItem(GUEST_WISHLIST_STORAGE_KEY);
}
